module.exports = __webpack_public_path__ + "img/杯子.ecee5de0.png";